import * as yup from "yup";

export const schema = yup.object().shape({
  id: yup.number().notRequired(),
  name: yup.string().required().min(3).max(50),
  description: yup.string().notRequired().max(255),
  icon: yup.string().notRequired().max(50),
  path_name: yup.string().required().min(3).max(50),
  layout: yup.string().notRequired().min(3).max(255),
  alias: yup.string().required().min(3).max(255),
  state: yup.string().required().min(3).max(50),
  collapse: yup.boolean().required(),
  order: yup.number().notRequired(),
});
